import React, { useEffect, useState } from "react";
import { Modal, modalStyles } from "@futures-platform/ui";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { requestTranslation } from "@futures-platform/i18n";
import styles from "./PublicLink.module.css";
import RefreshIcon from "@material-ui/icons/Refresh";
import RemoveIcon from "./Trash";
import { SharedLinkIcon } from "../icons/shareLinkIcon";
import styled from "styled-components";
import ToggleSwitcher from "./ToggleSwitcher";
import DatePicker from "react-datepicker";
import { radarAPIs } from "../../helpers/fetcher";

import "react-datepicker/dist/react-datepicker.css";

const PublicLink = ({
  openPublicLinkModal,
  isGroupOWnerOrCoordinator,
  onRequestCloseWhenHavingParamIs1,
  publicLinkModalWhenParamURLIs1,
  checkPublicLinkExsited,
  paramURLEqual,
  isNotModal,
  isRolesToShowPublicSharedLink,
  isModalOpen,
  onRequestClose,
  publicURL,
  openConfirmationModal,
  openDeleteConfirmationModal,
  expiredTime,
  isPublicShareUrlEnabled,
  public_shared_group_setting
}) => {
  const [shareInput, setShareInput] = useState("");
  const [linkCopied, setLinkCopied] = useState(false);
  const [isDeactivatedSharedLink, setisDeactivatedSharedLink] = useState(!isPublicShareUrlEnabled);
  const [isDeactivatedExpiredSharedLink, setisDeactivatedExpiredSharedLink] =
    useState((!!expiredTime || expiredTime !== 0) ? false : true);

// useEffect(() => {
//   setisDeactivatedSharedLink(() => isPublicShareUrlEnabled)
// }, [isPublicShareUrlEnabled])

  const [expiredTimestamp, setexpiredTimestamp] = useState((!!expiredTime || expiredTime !== 0) ? new Date(Date.parse(expiredTime)) : new Date())
  const params = new URLSearchParams(window.location.search);
  const radar = Number(params.get("node"));

  const onRequestCloseModal = () => {
    onRequestClose();
    setLinkCopied(false);
  };
  const onRequestCloseWhenHavingParamIs1Handler = () => {
    onRequestCloseWhenHavingParamIs1();
  };
  const handleChangeExpiryDate = (date) => {
    if (!!checkPublicLinkExsited) {
      setexpiredTimestamp(() => date);

      const payload = {
        login_expire: Date.parse(date)/1000,
      };
      radarAPIs.setExpiredSharedLink(radar, payload);
    }
    
  };

  // if url has param share = 1
  if (
    (paramURLEqual === 1 || paramURLEqual === "1") &&
    !!isGroupOWnerOrCoordinator &&
    !!checkPublicLinkExsited &&
    !publicURL.includes("oading") &&
    !!publicLinkModalWhenParamURLIs1
  ) {
    return (
      <Modal
        onRequestClose={onRequestCloseWhenHavingParamIs1Handler}
        isOpen={publicLinkModalWhenParamURLIs1}
        style={modalStyles}
        ariaHideApp={false}
        className={styles.ReactModal__Content}
      >
        <div
          className="modal-form-sections"
          style={{ background: "white !important" }}
        >
          <div className="modal-form-section modal-form-header">
            <h2 className={styles.Modal__Title}>
              {requestTranslation("publicLink")}
            </h2>

            {/* <p className="mt-4">{requestTranslation("publicLinkNote")}</p> */}
          </div>
          <div className="modal-form-section">
            <div
              style={{
                boxShadow: `rgba(0, 0, 0, 0.35) 0px 5px 15px`,
                marginTop: "25px",
                border: "1px solid lightgray",
                padding: "20px",
                width: "fit-content",
                pointerEvents: !!public_shared_group_setting ? 'unset': 'none', 
                opacity: !!public_shared_group_setting ? 1: 0.5
              }}
            >
              <div className="modal-form-header" style={{ padding: 0 }}>
                <div className={styles.titleWrapper}>
                  <div style={{ display: "flex" }}>
                    <div className={styles.SharedLinkIconWrapper}>
                      <SharedLinkIcon />
                    </div>
                    <h2
                      className={styles.Modal__Title}
                      style={{ fontSize: "16px" }}
                    >
                      {requestTranslation("copyTheSharedLink")}
                    </h2>
                  </div>
                  <ToggleSwitcher
                    labelText={requestTranslation('activatedSharedLink')}
                    isDeactivated={isDeactivatedSharedLink}
                    openPublicLinkModal={openPublicLinkModal}
                    setStatus={setisDeactivatedSharedLink}
                    checkPublicLinkExsited={checkPublicLinkExsited}
                  />
                </div>
                <p className="mt-4" style={{ fontSize: "14px" }}>
                  {requestTranslation("publicLinkNote")}
                </p>
              </div>

              {!isDeactivatedSharedLink && (
                <div style={{ marginTop: "33px", paddingTop: 0 }}>
                  <div style={{ fontWeight: 500 }}>
                    {requestTranslation("publicLinkURL")}
                  </div>
                  <div className="d-flex mt-2 align-items-center">
                    <input
                      className="form-control w-75"
                      value={publicURL}
                      readOnly
                      onFocus={(e) => e.target.select()}
                      type="text"
                      ref={(el) => {
                        setShareInput(el);
                      }}
                    />
                    <CopyToClipboard
                      text={publicURL}
                      onCopy={() => {
                        shareInput.focus();
                        setLinkCopied(true);
                      }}
                    >
                      <CopyToClipboardBtn
                        className="btn btn-outline-secondary ml-3 mr-3"
                        style={{ height: "35px", flexShrink: 0 }}
                      >
                        {requestTranslation("copyToClipboard")}
                      </CopyToClipboardBtn>
                    </CopyToClipboard>
                  </div>
                  {linkCopied && (
                    <h5
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "64px",
                        color: "#006998",
                      }}
                    >
                      {requestTranslation("publicLinkCopied")}
                    </h5>
                  )}
                  <div className="d-flex mt-3 align-items-center">
                    <PrimaryBtn
                      // disabled={!checked}
                      // className="btn btn-outline-secondary mr-3"
                      className={styles.RegenerateBtn}
                      onClick={openConfirmationModal}
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "#006998",
                        textTransform: "uppercase",
                      }}
                    >
                      <RefreshIcon />
                      <div style={{ paddingLeft: "4px" }}>
                        {requestTranslation("regeneratePublicLink")}
                      </div>
                    </PrimaryBtn>
                  </div>

                  <div className="d-flex mt-4 align-items-center">
                    {requestTranslation("regeneratePublicLinkNote")}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="modal-form-section modal-form-actions d-flex justify-content-between flex-end w-100 flex-row-reverse">
            {/* <button
                  className="btn btn-lg btn-plain-gray pl-0"
                  onClick={openDeleteConfirmationModal}
                >
                  {requestTranslation("deletePublicLinkBtn")}
                </button> */}
            <div className={styles.SavePublicLink__Container}>
              <button
                className={"btn btn-lg btn-plain-gray"}
                onClick={onRequestCloseWhenHavingParamIs1Handler}
              >
                {requestTranslation("Close")}
              </button>
              {/* <button
                    className={"btn btn-lg btn-primary"}
                    onClick={onRequestCloseModal}
                  >
                    {requestTranslation("save")}
                  </button> */}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
  // customer users and others else
  else if (!!isNotModal && !!isGroupOWnerOrCoordinator) {
    return (
      <div
        className="modal-form-sections"
        style={{ background: "white !important", pointerEvents: !!public_shared_group_setting ? 'unset': 'none', opacity: !!public_shared_group_setting ? 1: 0.5 }}
      >
        <div
          className="modal-form-section modal-form-header"
          style={{ padding: 0,  }}
        >
          <div className={styles.titleWrapper}>
            <div style={{ display: "flex" }}>
              <div className={styles.SharedLinkIconWrapper}>
                <SharedLinkIcon />
              </div>
              <h2 className={styles.Modal__Title} style={{ fontSize: "16px" }}>
                {requestTranslation("copyTheSharedLink")}
              </h2>
            </div>
            <ToggleSwitcher
              labelText={requestTranslation('activatedSharedLink')}
              isDeactivated={isDeactivatedSharedLink}
              openPublicLinkModal={openPublicLinkModal}
              setStatus={setisDeactivatedSharedLink}
              checkPublicLinkExsited={checkPublicLinkExsited}
            />
          </div>
          <p className="mt-4" style={{ fontSize: "14px" }}>
            {requestTranslation("publicLinkNote")}
          </p>
        </div>

        {!isDeactivatedSharedLink && (
          <div
            className="modal-form-section"
            style={{ padding: 0, marginTop: "16px" }}
          >
            <div style={{ fontWeight: 500 }}>
              {requestTranslation("publicLinkURL")}
            </div>
            <div className="d-flex mt-2 align-items-center">
              <input
                className="form-control w-75"
                value={publicURL}
                readOnly
                onFocus={(e) => e.target.select()}
                type="text"
                ref={(el) => {
                  setShareInput(el);
                }}
              />
              <CopyToClipboard
                text={publicURL}
                onCopy={() => {
                  shareInput.focus();
                  setLinkCopied(true);
                }}
              >
                <CopyToClipboardBtn
                  className={`btn btn-outline-secondary ml-3  ${styles.btnHover}`}
                  style={{ height: "35px", flexShrink: 0, marginRight: '2px' }}
                >
                  {requestTranslation("copyToClipboard")}
                </CopyToClipboardBtn>
              </CopyToClipboard>
            </div>
            {linkCopied && (
              <h5
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: "64px",
                  color: "#006998",
                }}
              >
                {requestTranslation("publicLinkCopied")}
              </h5>
            )}
            <div className="d-flex mt-3 align-items-center">
              <PrimaryBtn
                // disabled={!checked}
                // className="btn btn-outline-secondary mr-3"
                className={`${styles.RegenerateBtn} ${styles.btnHover}`}
                onClick={openConfirmationModal}
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  // color: '#006998',
                  textTransform: "uppercase",
                }}
              >
                <RefreshIcon />
                <div style={{ paddingLeft: "4px" }}>
                  {requestTranslation("regeneratePublicLink")}
                </div>
              </PrimaryBtn>
              <div
                style={{
                  // fontWeight: 'bold',
                  // fontSize: '14px',
                  // color: '#006998',
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                  marginLeft: "15%",
                }}
              >
                <ToggleSwitcher
                  labelText={requestTranslation('expiredTimeSharedLink')}
                  isDeactivated={isDeactivatedExpiredSharedLink}
                  setStatus={setisDeactivatedExpiredSharedLink}
                  type="expirationDate"
                  isNotShownLabel={true}
                  checkPublicLinkExsited={checkPublicLinkExsited}
                />
                <div
                  style={{
                    minWidth: "110px",
                    fontWeight: "500",
                  }}
                  className="mt-2 mb-2"
                >
                  {requestTranslation("expiredTimeSharedLink")}
                </div>
                <>
                    {
                      !isDeactivatedExpiredSharedLink && (
                        <DatePicker
                          disabled={isDeactivatedExpiredSharedLink}
                          selected={expiredTimestamp}
                          onChange={handleChangeExpiryDate}
                          placeholderText={requestTranslation("chooseDate")}
                          dateFormat="dd/MM/yyyy"
                          minDate={new Date()}
                        />
                      )
                    }
                  </>
              </div>
            </div>

            <div className="d-flex mt-4 align-items-center">
              {requestTranslation("regeneratePublicLinkNote")}
            </div>
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default PublicLink;

const PrimaryBtn = styled.button`
  &:hover {
    color: #0581b9 !important;
  }
`;
const CopyToClipboardBtn = styled.button`
  &:hover {
    background: #e8ebeb !important;
  }
`;
